import React, { useState, useContext, useEffect, useMemo } from 'react';

// Services
import { getUserGeolocalization } from '../../services/getRoute';

// Context
import GeneralContext from '../../context/GeneralContext';

// Components
import Toolbar from '../../components/UI/Toolbar/Toolbar';
import ConfigureRoute from '../../components/set-up-routePage/ConfigureRoute/ConfigureRoute';

// Interfaces
import { Route } from '../../interfaces/routes';
import { Location } from '../../interfaces/Location';

// Other
import { useLocation, useNavigate } from 'react-router-dom';

// SetupRoutePage: renders a Toolbar and the ConfigureRoute component
const SetupRoutePage: React.FC = () => {
    const { hospitalLocation } = useContext(GeneralContext);

    const location = useLocation();
    const route: Route = location.state.route;
    const loc: Location | undefined = location.state.location;

    const [userLocation, setUserLocation] = useState<Location | undefined>(loc);

    const navigate = useNavigate();

    const resolvedLocation = useMemo(() => {
        if (loc) return loc;
        if (route.start_from_hospital && hospitalLocation) return hospitalLocation;
        return userLocation;
    }, [hospitalLocation, loc, route.start_from_hospital, userLocation]);

    useEffect(() => {
        if (loc) return;
        if (route.start_from_hospital && hospitalLocation) return;

        const getUserLocation = async () => {
            const resPos = await getUserGeolocalization();

            if (resPos !== undefined) {
                setUserLocation(resPos);
            } else {
                navigate('/home/routes/routes_map_patients');
            }
        };

        getUserLocation();
    }, [hospitalLocation, loc, navigate, route.start_from_hospital]);

    return (
        <div className='pageContainer'>
            <Toolbar />
            {resolvedLocation !== undefined && (
                <ConfigureRoute
                    route={route}
                    userLocation={resolvedLocation}
                />
            )}
        </div>
    );
};

export default SetupRoutePage;